var baseUrl = document.baseURI;

export function ImageUrl($name) {
    return baseUrl + `images/${$name}`;
}
